import {useCallback, useEffect, useState} from "react";
import DatePicker from "react-datepicker";
import {Button, Spinner} from "react-bootstrap";
import FilterOrder from "../components/FilterOrder/FilterOrder";
import '../helpers/dateUtils';
import {CHAT_ID_AT} from "../constans";
import { normalizeProductName, keyCrmCreatedBetweenUtcFromRange } from "../helpers/utils";
import { AppRadio } from "../components/form/AppRadio.jsx";
import OrdersSoldNestedList from "../components/OrdersSoldNestedList/OrdersSoldNestedList.jsx";
import { WhoWorksToday } from "../components/WhoWorksToday/WhoWorksToday.jsx";
import { TodayUnfiscalizedOrders } from "../components/TodayUnfiscalizedOrders/TodayUnfiscalizedOrders.jsx";


export const Orders = ({user}) => {


    const [orders, setOrders] = useState([])
    const [source, setSource] = useState('all')
    const [manager, setManager] = useState('all')
    const [rangeDate, setRangeDate] = useState('day')
    const [timeLastUpdated, setTimeLastUpdated] = useState('')
    const [dataMessages, setDataMessages] = useState([]);

    const [range, setRange] = useState({
        startDate: new Date(),
        endDate: new Date()
    });
    const [isLoadingY, setLoadingY] = useState(false);
    const [isLoadingT, setLoadingT] = useState(false);
    const [ordersFetchLoading, setOrdersFetchLoading] = useState(true);
    const [soldListAggregation, setSoldListAggregation] = useState("none");
    const [soldListSort, setSoldListSort] = useState("sold");

    const multiSearchAtLeastN = (text, searchWords, minimumMatches) => {
        let matches = 0;
        for (let word of searchWords.split(",")) {
            if (text.join(" ").includes(word) && ++matches >= minimumMatches) return true;
        }
        return false;
    };


    //*** This code is copyright 2002-2016 by Gavin Kistner, !@phrogz.net
    //*** It is covered under the license viewable at http://phrogz.net/JS/_ReuseLicense.txt
    Date.prototype.customFormat = function(formatString){
        var YYYY,YY,MMMM,MMM,MM,M,DDDD,DDD,DD,D,hhhh,hhh,hh,h,mm,m,ss,s,ampm,AMPM,dMod,th;
        YY = ((YYYY=this.getFullYear())+"").slice(-2);
        MM = (M=this.getMonth()+1)<10?('0'+M):M;
        MMM = (MMMM=["January","February","March","April","May","June","July","August","September","October","November","December"][M-1]).substring(0,3);
        DD = (D=this.getDate())<10?('0'+D):D;
        DDD = (DDDD=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"][this.getDay()]).substring(0,3);
        th=(D>=10&&D<=20)?'th':((dMod=D%10)===1)?'st':(dMod===2)?'nd':(dMod===3)?'rd':'th';
        formatString = formatString.replace("#YYYY#",YYYY).replace("#YY#",YY).replace("#MMMM#",MMMM).replace("#MMM#",MMM).replace("#MM#",MM).replace("#M#",M).replace("#DDDD#",DDDD).replace("#DDD#",DDD).replace("#DD#",DD).replace("#D#",D).replace("#th#",th);
        h=(hhh=this.getHours());
        if (h===0) h=24;
        if (h>12) h-=12;
        hh = h<10?('0'+h):h;
        hhhh = hhh<10?('0'+hhh):hhh;
        AMPM=(ampm=hhh<12?'am':'pm').toUpperCase();
        mm=(m=this.getMinutes())<10?('0'+m):m;
        ss=(s=this.getSeconds())<10?('0'+s):s;
        return formatString.replace("#hhhh#",hhhh).replace("#hhh#",hhh).replace("#hh#",hh).replace("#h#",h).replace("#mm#",mm).replace("#m#",m).replace("#ss#",ss).replace("#s#",s).replace("#ampm#",ampm).replace("#AMPM#",AMPM);
    };

    const { startUtc, endUtc } = keyCrmCreatedBetweenUtcFromRange(range.startDate, range.endDate);

    const limit = "limit=500"
    const sort = "sort=id"
    const filter = encodeURIComponent("filter[created_between]") + "=" + encodeURIComponent(`${startUtc}, ${endUtc}`)
    const includes = "include=" + encodeURIComponent("buyer, shipping, manager, status, payments, products.offer, tags")

    const parameters = [limit, sort, filter, includes].join("&")

    /**
     * Робочий день: 09:00–24:00 (15 год.). Для кожного дня періоду рахуємо, скільки з цих 15 год.
     * вже минуло: минулі дні — повні 15 год., сьогодні — фактично пройдений час з 9:00 (не більше 15),
     * майбутні дні — 0. Раніше бралась різниця "від початку періоду до поточного моменту", тому на
     * будь-якому періоді, відмінному від "Сьогодні", години рахувались аж до зараз, а не до кінця періоду.
     */
    const WORK_DAY_HOURS = 15
    const WORK_START_HOUR = 9
    const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x }

    let workHours = 0
    const periodStart = startOfDay(range.startDate)
    const periodEnd = startOfDay(range.endDate)
    const today = startOfDay(new Date())
    for (let d = new Date(periodStart); d <= periodEnd; d.setDate(d.getDate() + 1)) {
        if (d.getTime() < today.getTime()) {
            workHours += WORK_DAY_HOURS
        } else if (d.getTime() === today.getTime()) {
            const dayStart = new Date(d)
            dayStart.setHours(WORK_START_HOUR, 0, 0, 0)
            const elapsedMs = Math.max(0, new Date() - dayStart)
            workHours += Math.min(WORK_DAY_HOURS, elapsedMs / (1000 * 60 * 60))
        }
    }
    /** Для ділення без нуля та з числовим типом */
    const workHoursNum = Math.max(0.01, workHours)


    const fetchDataMessages = useCallback(async () => {
        const response = await fetch('/api/messages/');
        const data = await response.json()
        setDataMessages(data);
    }, [])

    useEffect(() => {
        if (!user) return;

        setOrdersFetchLoading(true);
        const fetchData = async (parameters) => {
            try {
                const response = await fetch(`/api/orders?${parameters}`, {
                    credentials: "include"
                });

                if (!response.ok) {
                    console.error(`Помилка завантаження ${response.status}`);
                    if (response.status === 500) {
                        alert("Занадто часто, спробуйте пізніше");
                        console.error("Занадто часті запити");
                        return
                    }
                }

                const data = await response.json();
                if (Array.isArray(data)) {
                    setOrders(data);
                } else {
                    setOrders([]);
                }

                if (response.ok) {
                    setTimeLastUpdated(new Date().customFormat("#hhh#:#mm#:#ss#"));
                }

            } catch (error) {
                console.log("Request failed", error);
            } finally {
                setLoadingT(false);
                setLoadingY(false);
                setOrdersFetchLoading(false);
            }
        };

        fetchData(parameters);
    }, [parameters, source, user]);

    useEffect(() => {
        fetchDataMessages()
    }, []);

    const getSourceReturns = (order, source) => {
        const isOrderReturns = order.status.id === 20 || order.status.id === 21 || order.status.id === 39
        if (isOrderReturns) return source.returns = source.returns + 1
        else return source.returns
    }
    const getSourceGrandTotalReturns = (order, source) => {
        const isOrderReturns = order.status.id === 20 || order.status.id === 21 || order.status.id === 39
        if (isOrderReturns) return source.grandTotalReturns = +(Math.floor(source.grandTotalReturns + order.grand_total)).toFixed(0)
        else return source.grandTotalReturns
    }
    const getSourceMarginSumReturns = (order, source) => {
        const isOrderReturns = order.status.id === 20 || order.status.id === 21 || order.status.id === 39
        if (isOrderReturns) return source.marginSumReturns = +(Math.floor(source.marginSumReturns + order.margin_sum)).toFixed(0)
        else return source.marginSumReturns
    }
    const getSourceGrandTotal = (order, source) => {
        return source.grandTotal = +(Math.floor(source.grandTotal + order.grand_total)).toFixed(0)
    }
    const getSourceMarginSum = (order, source) => {
        return source.marginSum = +(Math.floor(source.marginSum + order.margin_sum)).toFixed(0)
    }

    const isReturn = (order) => [20, 21, 39].includes(order.status.id);

    const getSourceSales = (order, source) => {
        if (!isReturn(order)) {
            source.sales = (source.sales || 0) + 1;
        }
        return source.sales;
    }

    const getObjDataSource = (order, source) => {
        return {
            returns: getSourceReturns(order, source),
            grandTotalReturns: getSourceGrandTotalReturns(order, source),
            grandTotal: getSourceGrandTotal(order, source),
            marginSum: getSourceMarginSum(order, source),
            marginSumReturns: getSourceMarginSumReturns(order, source),
            sales: getSourceSales(order, source)
        }
    }
    const getDataSource = (order, source, source_id, source_id2) => {
        return order.source_id === source_id || order.source_id === source_id2 ? {...source, ...getObjDataSource(order, source)} : source
    }

    const handleClickYestarday = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        setRange(prevRange => ({
            ...prevRange,
            startDate: yesterday,
            endDate: yesterday
        }));
        setLoadingY(true);
    };

    const handleClickToday = () => {
        const today = new Date();
        setRange(prevRange => ({
            ...prevRange,
            startDate: today,
            endDate: today
        }));
        setLoadingT(true);
    };

    let arrManagers = []
    let arrSources = []
    let arrRanges = ["day", "week", "2weeks", "month", "year"]

    orders.forEach(order => {
        if (Object.keys(order).length === 0) return; // Пропускаем пустые заказы

        // Добавляем уникальных менеджеров
        if (!arrManagers.includes(order.manager.full_name)) {
            arrManagers.push(order.manager.full_name);
        }

        // Добавляем уникальные источники
        const sourceMapping = {
            1: "інстаграм",
            2: "telegram",
            4: "lava_underwear",
            9: "сайт",
            10: "шоурум Київ"
        };



        const sourceName = sourceMapping[order.source_id];
        if (sourceName && !arrSources.includes(sourceName)) {
            arrSources.push(sourceName);
        }
    });


    const filterByStatus = order => {
        if (Object.keys(order).length === 0) return false;
        const isOrderReturns = [20, 21, 39].includes(order.status.id);

        const isGroupValid =
            [1, 3, 4, 5].includes(order.status.group_id) ||
            (order.status.group_id === 6 && isOrderReturns) ||
            (order.status.group_id === 2 && order.status.id === 35);

        return isGroupValid;
    }

    const filterWithoutTelegram = order => Object.keys(order).length !== 0 && order.source_id !== 2;

    const filterByGrandTotal = order => {
        if (Object.keys(order).length === 0) return false;
        return order.grand_total > 0 || (order.grand_total === 0 && order.tags.some(t => t.id === 2));
    }

    const filterByTags = order => {
        if (Object.keys(order).length === 0) return false;
        return order.tags.every(tag => tag.id !== 1 && tag.id !== 4); // Исключаем Бартер (1) и Опт (4)
    }

    let sourceMap = {
        інстаграм: 1,
        telegram: 2,
        lava_underwear: 4,
        сайт: 9,
        "шоурум Київ": 10
    };

    let filteredOrders = orders
        .filter(filterByTags)
        .filter(filterByStatus)
        .filter(filterByGrandTotal)
        .filter(order => {
            if (Object.keys(order).length === 0) return false;

            const isManagerMatch = manager === "all" || order.manager.full_name === manager;
            const isSourceMatch = source === "all" || order.source_id === sourceMap[source];

            return isManagerMatch && isSourceMatch;
        });


    const hourlySalesOrders = filteredOrders
        .filter(filterWithoutTelegram)
        .filter((order) => order.status.id !== 39);
    const hourlySalesOrderCount = hourlySalesOrders.length;
    const hourlySalesGrandTotal = hourlySalesOrders.reduce(
        (s, o) => s + (Number(o.grand_total) || 0),
        0
    );

    function applyDiscount(p, name, discount) {
        if (p.name === name) {
            p.discount_amount = discount * p.quantity;
        }
    }

    function updateMargin(p) {
        p.margin_sum = p.price_sold - p.purchased_price - p.discount_amount;
    }

    function changeSuitesMarginSum(o, names) {
        const suites = [
            { products: ["Мастерка", "Майстерка", "Карго 2023", "Карго"], discount: 150 },
            { products: ["Палаццо", "Жилет"], discount: 160 },
            { products: ["Худі петля", "Джогери петля"], discount: 150 },
            // Добавьте другие пакеты по аналогии
        ];

        suites.forEach(suite => {
            if (multiSearchAtLeastN(names, suite.products.join(","), 2)) {
                o.products.forEach(p => {
                    if (suite.products.some(product => p.name.includes(product))) {
                        p.discount_amount = suite.discount;
                        updateMargin(p);
                    }
                });
            }
        });
    }

    filteredOrders.forEach((o) => {
        const names = o.products.map(item => item.name.includes(" - ") ? item.name.split(" - ")[0].trim() : item.name);

        // Обработка дублей
        const arrDuplicate = o.products.filter((p, index, self) => self.findIndex(t => t.name === p.name) !== index);

        // Обработка товаров
        if (o.discount_amount === 0) {
            o.products.forEach((p) => {
                p.margin_sum = p.price_sold - p.purchased_price;
            });
        } else {
            o.products.forEach(p => {
                arrDuplicate.forEach(d => {
                    applyDiscount(p, d.name, 90);  // Пример применения скидки для дублей
                });
                updateMargin(p);
            });
            changeSuitesMarginSum(o, names);
        }
    });

    let grand_total = 0
    let quantityProducts = 0
    let margin_sum = 0
    let numberOfClearanceSales = 0
    let quantityRepeatSales = 0
    let quantityInstagramSales = 0
    let totalUpsale = 0
    let totalGTReturns = 0

    let arrProducts = []

    let totalDataSource = {
        instagram: {
            returns: 0,
            sales: 0,
            grandTotalReturns: 0,
            marginSumReturns: 0,
            marginSum: 0,
            grandTotal: 0
        },
        telegram: {
            returns: 0,
            sales: 0,
            grandTotalReturns: 0,
            marginSumReturns: 0,
            marginSum: 0,
            grandTotal: 0
        },
        site: {
            returns: 0,
            sales: 0,
            grandTotalReturns: 0,
            marginSumReturns: 0,
            marginSum: 0,
            grandTotal: 0
        },
        showroom: {
            returns: 0,
            sales: 0,
            grandTotalReturns: 0,
            marginSumReturns: 0,
            marginSum: 0,
            grandTotal: 0
        },
    }


    const getLocaleDate = (utcDate) => {
        const date = new Date(utcDate);

        return date.toLocaleDateString("uk-UA", {
            day: "numeric",
            month: "short"
        }).replace(".", "");
    };

    const getOrdersByRange = (arr, range) => {

        return arr.reduce((a, c) => {
            let eDate, cDate;
            let idx = a.findIndex((e) => {
                switch (range) {
                    case 'day':
                        eDate = getLocaleDate(e[0].created_at)
                        cDate = getLocaleDate(c.created_at)
                        break;
                    case 'week':
                        eDate = new Date(e[0].created_at).getWeek()
                        cDate = new Date(c.created_at).getWeek()
                        break;
                    case '2weeks':
                        eDate = new Date(e[0].created_at).get2Weeks()
                        cDate = new Date(c.created_at).get2Weeks()
                        break;
                    case 'month':
                        eDate = new Date(e[0].created_at).getMonth()
                        cDate = new Date(c.created_at).getMonth()
                        break;
                    case 'year':
                        eDate = new Date(e[0].created_at).getFullYear()
                        cDate = new Date(c.created_at).getFullYear()
                        break;
                    default:
                        return false;
                }
                return eDate === cDate
            });
            if (idx !== -1) a[idx].push(c);
            else a.push([c]);
            return a;
        }, []);
    }
    let ranges = {}
    ranges.ranges = getOrdersByRange(filteredOrders, rangeDate)

    filteredOrders.filter(filterWithoutTelegram).forEach(order => {
        const isOrderReturns = order.status.id === 20 || order.status.id === 21 || order.status.id === 39
        grand_total = grand_total + order.grand_total
        totalGTReturns = isOrderReturns ? totalGTReturns + order.grand_total : totalGTReturns

        margin_sum = margin_sum + order.margin_sum
        if (order.tags.length !== 0) {
            order.tags.forEach(tag => {
                if (tag.id === 5) return quantityRepeatSales++
                if (tag.id === 6) return numberOfClearanceSales++
                if (tag.id === 6) return quantityInstagramSales++
            })
        }

        totalDataSource.instagram = getDataSource(order, totalDataSource.instagram, 1, 4)
        totalDataSource.telegram  = getDataSource(order, totalDataSource.telegram, 2)
        totalDataSource.site      = getDataSource(order, totalDataSource.site, 9)
        totalDataSource.showroom  = getDataSource(order, totalDataSource.showroom, 10)


        // console.log("order: ", order)


        order.products.forEach(product => {
            // Проверяем наличие дефиса и обрезаем строку до него
            const productName = normalizeProductName(product.name);

            totalUpsale = product.upsale ? totalUpsale + 1 : totalUpsale;
            quantityProducts = quantityProducts + product.quantity;

            arrProducts.push({
                name: productName, // Используем обрезанное имя
                quantity: product.quantity,
                margin_sum: product.margin_sum
            });
        });

    })

    let productsAllOfPeriod = arrProducts.reduce((a, c) => {
        let idx = a.findIndex((e) => e.name === c.name);
        if (idx === -1) a.push(c);
        else {
            a[idx].quantity = (Number(a[idx].quantity) || 0) + (Number(c.quantity) || 0);
            a[idx].margin_sum = (Number(a[idx].margin_sum) || 0) + (Number(c.margin_sum) || 0);
        }
        return a;
    }, []);

    const productsAllOfPeriodSorted = [...productsAllOfPeriod]
        .map(p => ({ ...p, quantity: Number(p.quantity) || 0 }))
        .sort((a, b) => {
            if (b.quantity !== a.quantity) return b.quantity - a.quantity;
            return a.name.localeCompare(b.name, "uk"); // стабильность при равных qty
        });

    const onFilterValueSelected = filterValue => setSource(filterValue)
    const onManagerSelected = manager => setManager(manager)
    const onRangeSelected = range => setRangeDate(range)

    const ordersCountExcludingStatus39 = (ordersList) =>
        ordersList.filter((o) => o.status.id !== 39).length;

    const fmtMarginPct = (mSum, gTotal) => {
        if (!gTotal || gTotal <= 0) return "—";
        const pct = (100 * mSum) / gTotal;
        return `${pct.toLocaleString("uk-UA", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        })}%`;
    };

    const fmtUnitsPerOrder = (units, ordersInPeriod) => {
        if (!ordersInPeriod || ordersInPeriod <= 0) return "—";
        const v = units / ordersInPeriod;
        return v.toLocaleString("uk-UA", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        });
    };

    const footerOrdersForAvgUnits = filteredOrders.filter(filterWithoutTelegram);
    const footerOrdersCountAvg = footerOrdersForAvgUnits.length;

    const deleteMessage = async () => {
        // Проверка, если массив данных пуст
        if (dataMessages.length === 0) {
            console.log("No messages to delete.");
            return;
        }

        const lastMessage = dataMessages[dataMessages.length - 1];
        const lastMessageId = lastMessage._id;
        const lastMessageIdTelegram = lastMessage.message_id;

        try {
            // Запрос на удаление сообщения с сервера
            const response = await fetch(`/api/messages/${lastMessageId}`, {
                method: "DELETE",
            });

            if (!response.ok) {
                console.error("Can't delete message. Server error.");
                return;
            }

            // Фильтрация сообщений после удаления
            const filteredData = dataMessages.filter((message) => message._id !== lastMessageId);
            setDataMessages(filteredData);

            // Отправка запроса на удаление сообщения в Telegram
            const telegramResponse = await fetch(
                `https://api.telegram.org/bot5346603542:AAFy1TKplf7w8EG2rdVigK-DvXTTjEjWDtg/deleteMessage?chat_id=${CHAT_ID_AT}&message_id=${lastMessageIdTelegram}`
            );

            if (!telegramResponse.ok) {
                console.error("Telegram API error.")
            }

        } catch (error) {
            console.error("Error occurred:", error);
        }
    };

    return (<div className="d-flex flex-column flex-grow-1 w-100" style={{ minHeight: 0 }}>
        <header className="header-orders">
            <div className="section-controls orders-page-section-controls">
                <div className="orders-page-heading">
                    <h1 className="orders-page-title">Замовлення</h1>
                    <p className="orders-page-updated text-muted small mb-0 fw-normal">
                        Updated at {timeLastUpdated}
                    </p>
                </div>
                <div className="orders-page-toolbar">
                    <div className="orders-page-toolbar-dates">
                        <div className="holder-datapickers">
                            <DatePicker
                                dateFormat="dd.MM.yyyy"
                                locale="uk"
                                selected={range.startDate}
                                onChange={(date) =>
                                    setRange((prevRange) => ({
                                        ...prevRange,
                                        startDate: date,
                                    }))
                                }
                            />
                            <DatePicker
                                dateFormat="dd.MM.yyyy"
                                locale="uk"
                                selected={range.endDate}
                                onChange={(date) =>
                                    setRange((prevRange) => ({
                                        ...prevRange,
                                        endDate: date,
                                    }))
                                }
                            />
                        </div>
                    </div>
                    <div
                        className="orders-page-toolbar-actions"
                        role="group"
                        aria-label="Швидкий вибір періоду"
                    >
                        <Button
                            className="orders-toolbar-btn"
                            variant="outline-dark"
                            onClick={!isLoadingT ? handleClickToday : null}
                        >
                            {isLoadingT ? (
                                <Spinner
                                    animation="border"
                                    size="sm"
                                    className="text-dark"
                                />
                            ) : (
                                "Сьогодні"
                            )}
                        </Button>
                        <Button
                            className="orders-toolbar-btn"
                            variant="outline-dark"
                            onClick={!isLoadingY ? handleClickYestarday : null}
                        >
                            {isLoadingY ? (
                                <Spinner
                                    animation="border"
                                    size="sm"
                                    className="text-dark"
                                />
                            ) : (
                                "Вчора"
                            )}
                        </Button>
                    </div>
                    <div className="orders-page-toolbar-filters">
                        <FilterOrder
                            options={arrSources}
                            filterValueSelected={onFilterValueSelected}
                        />
                        <FilterOrder
                            options={arrManagers}
                            filterValueSelected={onManagerSelected}
                        />
                        <FilterOrder
                            options={arrRanges}
                            filterValueSelected={onRangeSelected}
                        />
                    </div>
                </div>
            </div>
        </header>
        <main className="d-flex flex-column flex-grow-1 w-100" style={{ minHeight: 0 }}>
            <div className="container-fluid px-0 d-flex flex-column flex-grow-1 w-100" style={{ minHeight: 0 }}>
                <section className={`section-table table-sticky-wrapper section-table--orders-page${ordersFetchLoading ? " d-flex flex-column flex-grow-1" : ""}`} style={ordersFetchLoading ? { minHeight: 0 } : undefined}>
                    <WhoWorksToday />
                    <TodayUnfiscalizedOrders />
                    {ordersFetchLoading ? (
                    <div
                        className="d-flex flex-grow-1 justify-content-center align-items-center bg-body w-100"
                        style={{ minHeight: 0 }}
                    >
                        <Spinner
                            animation="border"
                            role="status"
                            aria-busy="true"
                            className="text-black"
                            style={{ width: "3rem", height: "3rem" }}
                        />
                    </div>
                    ) : (
                    <>
                    <div className="orders-page-hourly-summary text-muted small px-3 pt-1 mb-2">
                        На годину:{" "}
                        <strong className="text-body">
                            {+(hourlySalesOrderCount / workHoursNum).toFixed(1)}
                        </strong>{" "}
                        замовлень ·{" "}
                        <strong className="text-body">
                            {Math.floor(hourlySalesGrandTotal / workHoursNum).toLocaleString(
                                "uk-UA"
                            )}
                        </strong>{" "}
                        грн · ср. чек{" "}
                        <strong className="text-body">
                            {hourlySalesOrderCount > 0
                                ? Math.floor(
                                      hourlySalesGrandTotal / hourlySalesOrderCount
                                  ).toLocaleString("uk-UA")
                                : "—"}
                        </strong>{" "}
                        грн
                    </div>
                    <div className="orders-table-horizontal-scroll">
                    <div className="holder-table">
                        <table className="table table-orders table-sticky table-light table-bordered table-striped thead-dark">
                            <thead className="stiky">
                            <tr>
                                {
                                    <>
                                        <th>дата</th>
                                        <th>Кількість замовлень</th>
                                        <th>Кількість Instagram</th>
                                        <th>Кількість Telegram</th>
                                        <th>Кількість Site</th>
                                        <th>Кількість Showroom</th>
                                        <th>Кількість повторних продажів, шт.</th>
                                        <th>Кількість замовлень з SALE, шт.</th>
                                        <th>Загальна вартість, грн.</th>
                                        <th>Маржа, грн.</th>
                                        <th>Маржинальність, %</th>
                                        <th>ТО <br/> Instagram</th>
                                        <th>ТО <br/> Telegram</th>
                                        <th>ТО <br/> Site</th>
                                        <th>ТО <br/> Showroom</th>
                                        <th>ТО <br/> повернень</th>
                                        <th>Кількість повернень</th>
                                        <th>Середній чек, грн.</th>
                                        <th>Кількість допродажів</th>
                                        <th>Одиниць товару на замовлення</th>
                                        <th>Кількість товарів, шт.</th>
                                        {productsAllOfPeriodSorted.map(p => <th className="product-name" key={p.name}>{p.name}</th>)}
                                    </>
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {ranges.ranges.map((range, i) => {
                                let grand_total = 0
                                let quantityProducts = 0
                                let quantityUpsale = 0
                                let margin_sum = 0
                                let numberOfClearanceSales = 0
                                let quantityRepeatSales = 0
                                let total_returns = 0
                                let grand_total_returns = 0
                                let instagram = {
                                    grandTotal: 0, returns: 0, sales: 0
                                }
                                let telegram = {
                                    grandTotal: 0, returns: 0, sales: 0
                                }
                                let site = {
                                    grandTotal: 0, returns: 0, sales: 0
                                }
                                let showroom = {
                                    grandTotal: 0, returns: 0, sales: 0
                                }
                                let arr = []

                                range.forEach(order => {
                                    const isOrderReturns = order.status.id === 20 || order.status.id === 21 || order.status.id === 39
                                    grand_total = grand_total + order.grand_total
                                    total_returns = isOrderReturns ? total_returns + 1 : total_returns
                                    grand_total_returns = isOrderReturns ? grand_total_returns + order.grand_total : grand_total_returns

                                    margin_sum = margin_sum + order.margin_sum

                                    instagram = getDataSource(order, instagram, 1, 4)
                                    telegram  = getDataSource(order, telegram, 2)
                                    site      = getDataSource(order, site, 9)
                                    showroom  = getDataSource(order, showroom, 10)


                                    if (order.tags.length !== 0) {
                                        order.tags.forEach(tag => {
                                            if (tag.id === 5) return quantityRepeatSales++
                                            if (tag.id === 6) return numberOfClearanceSales++
                                        })
                                    }

                                    order.products.forEach(product => {
                                        quantityUpsale = product.upsale ? quantityUpsale + 1 : quantityUpsale
                                        quantityProducts = quantityProducts + product.quantity
                                        arr.push({
                                            name: normalizeProductName(product.name),
                                            quantity: product.quantity
                                        });
                                    })
                                })

                                let productsDay = arr.reduce((a, c) => {
                                    let idx = a.findIndex((e) => e.name === c.name);
                                    if (idx === -1) a.push(c)
                                    else a[idx].quantity = a[idx].quantity + c.quantity
                                    return a;
                                }, []);

                                const productsDayMap = {};

                                productsDay.forEach(p => {
                                    productsDayMap[p.name] = p.quantity;
                                });


                                return <tr key={i} className="day-data">
                                    <td className="first-cell">{getLocaleDate(range[0].created_at)}</td>
                                    <td>{range.filter(order => order.status.id !== 39).length}</td>
                                    <td>{instagram.sales}</td>
                                    <td>{telegram.sales}</td>
                                    <td>{site.sales}</td>
                                    <td>{showroom.sales}</td>
                                    <td>{quantityRepeatSales}</td>
                                    <td>{numberOfClearanceSales}</td>
                                    <td>{Math.floor(grand_total)}</td>
                                    <td>{Math.floor(margin_sum)}</td>
                                    <td>{fmtMarginPct(margin_sum, grand_total)}</td>
                                    <td>{instagram.grandTotal}</td>
                                    <td>{telegram.grandTotal}</td>
                                    <td>{site.grandTotal}</td>
                                    <td>{showroom.grandTotal}</td>
                                    <td>{Math.floor(grand_total_returns)}</td>
                                    <td>{total_returns}</td>
                                    <td>{Math.floor(grand_total/range.length)}</td>
                                    <td>{quantityUpsale}</td>
                                    <td>{fmtUnitsPerOrder(quantityProducts, ordersCountExcludingStatus39(range))}</td>
                                    <td>{quantityProducts}</td>
                                    {productsAllOfPeriodSorted.map(valueTh => {
                                        return (
                                            <td key={valueTh.name}>
                                                {productsDayMap[valueTh.name] || ""}
                                            </td>
                                        );
                                    })}
                                </tr>
                            })}
                            </tbody>
                            {ranges.ranges.length > 1 && <tfoot>
                            <tr className="day-data">
                                <td className="first-cell"><strong>Взагалом</strong></td>
                                <td><strong>{filteredOrders.filter(order => order.status.id !== 39).length}</strong></td> {/*Убираю дубль-заказ частичного возврата при подсчете заказов*/}
                                <td>{totalDataSource.instagram.sales}</td>
                                <td>{totalDataSource.telegram.sales}</td>
                                <td>{totalDataSource.site.sales}</td>
                                <td>{totalDataSource.showroom.sales}</td>
                                <td><strong>{quantityRepeatSales}</strong></td>
                                <td><strong>{numberOfClearanceSales}</strong></td>
                                <td><strong>{Math.floor(grand_total)}</strong></td>
                                <td><strong>{Math.floor(margin_sum)}</strong></td>
                                <td><strong>{fmtMarginPct(margin_sum, grand_total)}</strong></td>
                                <td>{totalDataSource.instagram.grandTotal}</td>
                                <td>{totalDataSource.telegram.grandTotal}</td>
                                <td>{totalDataSource.site.grandTotal}</td>
                                <td>{totalDataSource.showroom.grandTotal}</td>
                                <td>{Math.floor(totalGTReturns)}</td>
                                <td>{totalDataSource.instagram.returns+totalDataSource.telegram.returns+totalDataSource.site.returns+totalDataSource.showroom.returns}</td>
                                <td><strong>{Math.floor(grand_total/filteredOrders.length)}</strong></td>
                                <td><strong>{totalUpsale}</strong></td>
                                <td><strong>{fmtUnitsPerOrder(quantityProducts, footerOrdersCountAvg)}</strong></td>
                                <td><strong>{quantityProducts}</strong></td>
                                {productsAllOfPeriodSorted.map((p, i) => <td key={i}><strong>{p.quantity}</strong></td>)}
                            </tr>
                            </tfoot>}
                        </table>
                    </div>
                    </div>
                    </>
                    )}
                    {!ordersFetchLoading && (
                        <>
                            <div className="orders-sold-nested-panel">
                                <div className="orders-sold-nested-heading">Продані позиції (детально)</div>
                                <div className="orders-sold-agg-radios">
                                    <AppRadio
                                        id="orders-sold-agg-none"
                                        name="orders-sold-aggregation"
                                        value="none"
                                        checked={soldListAggregation === "none"}
                                        onChange={() => setSoldListAggregation("none")}
                                        label="Без агрегації"
                                        title="Окремо кожна пара колір + розмір + SKU."
                                    />
                                    <AppRadio
                                        id="orders-sold-agg-color"
                                        name="orders-sold-aggregation"
                                        value="color"
                                        checked={soldListAggregation === "color"}
                                        onChange={() => setSoldListAggregation("color")}
                                        label="За кольорами"
                                        title="У межах одного товару: для кожного кольора зводимо продажі по всіх розмірах цього кольору."
                                    />
                                    <AppRadio
                                        id="orders-sold-agg-size"
                                        name="orders-sold-aggregation"
                                        value="size"
                                        checked={soldListAggregation === "size"}
                                        onChange={() => setSoldListAggregation("size")}
                                        label="За розмірами"
                                        title="У межах одного товару: для кожного розміру зводимо продажі по всіх кольорах цього розміру."
                                    />
                                </div>
                                <div className="orders-sold-sort-caption text-muted small">Упорядкування:</div>
                                <div className="orders-sold-sort-radios">
                                    <AppRadio
                                        id="orders-sold-sort-sold"
                                        name="orders-sold-sort"
                                        value="sold"
                                        checked={soldListSort === "sold"}
                                        onChange={() => setSoldListSort("sold")}
                                        label="За кількістю проданого"
                                        title="Товари, кольори, розміри та рядки — спершу найбільш продані."
                                    />
                                    <AppRadio
                                        id="orders-sold-sort-alpha"
                                        name="orders-sold-sort"
                                        value="alphabet"
                                        checked={soldListSort === "alphabet"}
                                        onChange={() => setSoldListSort("alphabet")}
                                        label="За назвою (А–Я)"
                                        title="Алфавітна верстка назв за локаллю uk."
                                    />
                                </div>
                                <OrdersSoldNestedList
                                    orders={filteredOrders.filter(filterWithoutTelegram)}
                                    aggregationMode={soldListAggregation}
                                    sortOrder={soldListSort}
                                />
                            </div>
                        </>
                    )}
                   </section>
            </div>
        </main>
    </div>
    );
}